import React, { useState, useEffect } from 'react';
import { API } from '../config';

function classKeyLabel(k) {
  const parts = k.split('|');
  return parts.length === 2 ? `${parts[0]} · ${parts[1]}` : k;
}

export default function ClassConfirmations({ currentUser, onRefresh }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;
    setLoading(true);
    fetch(`${API.apiBase}/api/class-confirmations?userId=${currentUser.id}`)
      .then(r => r.json())
      .then(data => { setList(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [currentUser]);

  async function handleAction(id, action) {
    try {
      const r = await fetch(`${API.apiBase}/api/class-confirmations/${id}/${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: currentUser.id })
      });
      if (r.ok) {
        setList(prev => prev.filter(c => c.id !== id));
        if (onRefresh) onRefresh();
      }
    } catch {}
  }

  if (loading) return null;
  if (list.length === 0) return null;

  const myConfirmations = list.filter(c => c.isMine);
  const othersConfirmations = list.filter(c => !c.isMine);

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#e91e63', marginBottom: 8 }}>🤝 同班确认</div>

      {othersConfirmations.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: '#999', marginBottom: 4 }}>以下是新同学，认识的话点确认：</div>
          {othersConfirmations.map(c => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#fff8e1', borderRadius: 8, marginBottom: 6, border: '1px solid #ffe082' }}>
              <div>
                <span style={{ fontWeight: 600, fontSize: 14 }}>{c.newUserName}</span>
                <span style={{ fontSize: 12, color: '#999', marginLeft: 8 }}>{classKeyLabel(c.classKey)}</span>
                {c.newUserHeadTeacher && <span style={{ fontSize: 12, color: '#ff9800', marginLeft: 6 }}>班主任: {c.newUserHeadTeacher}</span>}
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => handleAction(c.id, 'confirm')} style={{ padding: '4px 12px', border: 'none', borderRadius: 12, background: '#4caf50', color: '#fff', fontSize: 12, cursor: 'pointer' }}>✓ 确认</button>
                <button onClick={() => handleAction(c.id, 'reject')} style={{ padding: '4px 12px', border: 'none', borderRadius: 12, background: '#f44336', color: '#fff', fontSize: 12, cursor: 'pointer' }}>✗ 不是</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {myConfirmations.length > 0 && (
        <div>
          <div style={{ fontSize: 12, color: '#999', marginBottom: 4 }}>你的确认请求：</div>
          {myConfirmations.map(c => (
            <div key={c.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#f3e5f5', borderRadius: 8, marginBottom: 6 }}>
              <div>
                <span style={{ fontWeight: 600, fontSize: 14 }}>{c.newUserName}</span>
                <span style={{ fontSize: 12, color: '#999', marginLeft: 8 }}>{classKeyLabel(c.classKey)}</span>
              </div>
              <span style={{ fontSize: 12, color: '#7c4dff', fontWeight: 500 }}>
                等待 {Math.max(0, 2 - c.confirmedBy.length)} 位同学确认
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}